/**
 * Created by ewald.stamp on 18.08.2014.
 */

angular.module('cfn').factory('TermAcceptanceHttpProxy', [
  '$http',
  function($http) {
    'use strict';

    var baseUrl = '/365FarmNet/rest/user/acceptTerms';

    var TermAcceptanceHttpProxy = {};

    TermAcceptanceHttpProxy.accept = function(permissionToBeContacted) {
      var terms = {
        acceptTerms: true,
        permissionToBeContacted: permissionToBeContacted
      };

      return $http.post(baseUrl, terms);
    };

    TermAcceptanceHttpProxy.check = function() {
      return $http.get(baseUrl);
    };

    return TermAcceptanceHttpProxy;
  }
]);
